import { PRODUCT_BULK_ELIGIBILITY_OUTCOMES } from "@price-rescue/domain/product-bulk-actions";
import { freezeProductBulkSelection } from "./product-bulk-selection.js";
import type { BulkEligibilityResult, BulkEligibilityUpdate, ProductRow } from "./models.js";

export function buildConfirmedEligibilityUpdates(
  products: ProductRow[],
  productIds: string[],
  decision: { eligible: boolean; reason: string; merchantNote?: string },
): BulkEligibilityUpdate[] {
  const ids = freezeProductBulkSelection(productIds);
  if (ids.some((id) => !products.some((product) => product.productId === id))) {
    throw new Error("The selected page changed. Review the current products before confirming.");
  }
  return products
    .filter((product) => ids.includes(product.productId))
    .map((product) => ({
      productId: product.productId,
      eligible: decision.eligible,
      reason: decision.reason,
      ...(decision.merchantNote?.trim() ? { merchantNote: decision.merchantNote.trim() } : {}),
    }));
}

export function unconfirmedEligibilityResult(
  updates: BulkEligibilityUpdate[],
): BulkEligibilityResult {
  return {
    updated: [],
    failed: [],
    skipped: [],
    unconfirmed: updates.map(({ productId }) => ({
      productId,
      code: PRODUCT_BULK_ELIGIBILITY_OUTCOMES.UNCONFIRMED,
      message: "The outcome is unknown. Refresh and review before retrying.",
    })),
  };
}
